import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  return (
    <section className="policy-page">
      <div className="policy-container">
        <h1 className="policy-heading">{t("privacyPolicy.title")}</h1>
        <p className="policy-text">{t("privacyPolicy.intro")}</p>
        <h2 className="policy-subheading">{t("privacyPolicy.dataCollectionTitle")}</h2>
        <p className="policy-text">{t("privacyPolicy.dataCollectionBody")}</p>
        <h2 className="policy-subheading">{t("privacyPolicy.dataUseTitle")}</h2>
        <p className="policy-text">{t("privacyPolicy.dataUseBody")}</p>
        <h2 className="policy-subheading">{t("privacyPolicy.contactTitle")}</h2>
        <p className="policy-text">{t("privacyPolicy.contactBody")}</p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
